import { PlusCircleTwoTone } from "@ant-design/icons";
import { Col, Space } from "antd";
import GroupsList from "./groupsList";
import "./styles.css";
import PopUpNewGroup from "./popUpNewGroup";
import { groupTripsRequestList } from "../../../features/groupTrip/groupTripRequest/groupTripRequestSlide";
import { useAppDispatch } from "../../../app/hooks";
import ContainerLayout from "../../common/containerLayout";
import SelectClients from "../common/selectClients";

interface SearchValue {
  value: string;
}

const GroupTrip = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const handleOnChange = ({ value }: SearchValue) => {
    dispatch(groupTripsRequestList(value));
  };

  return (
    <ContainerLayout title="Solicitudes Viajes en grupo">
      <Col span={24}>
        <Space>
          <PopUpNewGroup
            text="Viaje en grupo"
            modalTitle="Crear nueva planificacion"
            icon={<PlusCircleTwoTone />}
          />
          <SelectClients style={{ width: 230 }} onChange={handleOnChange} />
        </Space>
      </Col>
      <Col span={24} style={{ width: "100px", height: "83vh" }}>
        <GroupsList />
      </Col>
    </ContainerLayout>
  );
};

export default GroupTrip;
